import { render } from "./GeneratePatientDoc.vue?vue&type=template&id=726f2c16"
import script from "./GeneratePatientDoc.vue?vue&type=script&lang=js"
export * from "./GeneratePatientDoc.vue?vue&type=script&lang=js"

import "./GeneratePatientDoc.vue?vue&type=style&index=0&id=726f2c16&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__